var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaAvanzarRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 13",
    width: 7,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flecha-avanzar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #7d00fc } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PANTALLAS-ESCAPE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pantalla-Instrucciones"
  }, /*#__PURE__*/React.createElement("path", {
    id: "avanzar",
    className: "s0",
    d: "m0.75 13c-0.19 0-0.39-0.07-0.53-0.22-0.29-0.3-0.29-0.78 0-1.08l5-5.2-5-5.19c-0.29-0.3-0.29-0.78 0-1.08 0.29-0.3 0.75-0.3 1.04-0.02l5.53 5.74q0.21 0.23 0.21 0.55-0.01 0.31-0.21 0.54l-5.53 5.74q-0.23 0.22-0.51 0.22z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaAvanzarRed);
export default __webpack_public_path__ + "static/media/flecha-avanzar-red.71a62fd955d1011adfd3f8bb734be664.svg";
export { ForwardRef as ReactComponent };